import React from 'react'
import { Box, Card } from '@material-ui/core'
import { useStyles } from './styles'

const SummaryInfoCards = ({ users }) => {
  const classes = useStyles()
  const runtSorted = users?.runt?.sort(
    (a, b) =>
      new Date(b?.FECHA_MATRICULA).getTime() -
      new Date(a?.FECHA_MATRICULA).getTime(),
  )

  if (!users || !users.runt || !Array.isArray(runtSorted)) {
    return null // Render nothing if users or users.runt is not available
  }

  return (
    <Card className={classes.mainContainer}>
      {runtSorted.map((value) => (
        <Box key={Math.random()} className={classes.userContainer}>
          {Object.entries(value).map(
            (element) =>
              (element[0] === 'PLACA' ||
                element[0] === 'LINEA' ||
                element[0] === 'MARCA' ||
                element[0] === 'FECHA_MATRICULA') && (
                <Box className={classes.container} key={element[0]}>
                  <Box className={classes.titles}>
                    <strong>{element[0]?.toUpperCase()}</strong>
                  </Box>
                  <Box className={classes.description}>
                    {element[0] === 'FECHA_MATRICULA'
                      ? element[1]?.slice(0, 10).toUpperCase()
                      : element[1]?.toUpperCase()}
                  </Box>
                </Box>
              ),
          )}
        </Box>
      ))}
    </Card>
  )
}

export default SummaryInfoCards
